import { Col, Row } from "antd";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import SkipReasonContext from "../../../context/skip-reason/context";
import Form from "../../form-components/from";
import { INITIAL_PAGE } from "../../../utils/helpers/constants";
import FieldBuilder from "../../form-components/field-builder";

interface IProps {}

const SkipReasonFilter: React.FC<IProps> = () => {
  const { t } = useTranslation();
  const { actions, query } = useContext(SkipReasonContext);

  const skipTypeOptions = [
    { label: t("store"), value: true },
    { label: t("order"), value: false },
  ];

  const activeOptions = [
    { label: t("active"), value: true },
    { label: t("inactive"), value: false },
  ];

  return (
    <Form
      formId="skip-reason-filter"
      onSubmit={(data) => {
        const filter: any = {
          page: INITIAL_PAGE,
          perPage: query?.perPage,
          keyword: data?.keyword,
          is_store_skip: data?.is_store_skip,
          is_active: data?.is_active,
        };
        actions.setQuery(filter);
      }}
    >
      <Row justify={"start"} gutter={[10, 0]}>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
          <FieldBuilder
            name="is_store_skip"
            label={`${t("skip_type")}`}
            width="large"
            input={{
              type: "select",
              options: skipTypeOptions,
            }}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
          <FieldBuilder
            name="is_active"
            label={`${t("status")}`}
            width="large"
            input={{
              type: "select",
              options: activeOptions,
            }}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default SkipReasonFilter;
